import { useParams } from 'react-router-dom'

export const useEventListIdParam = () => {
  const { eventListId } = useParams()

  if (!eventListId)
    throw new Error('Must be used on a route with an eventListId param')
  return { eventListId }
}
